import { Link } from "react-router-dom";
import { Lock, FileText, Eye, ArrowUpRight } from "lucide-react";

export default function PaperCard({ paper, index = 0 }) {
  const date = paper.created_at
    ? new Date(paper.created_at).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })
    : "";

  return (
    <Link
      to={`/paper/${paper.slug}`}
      data-testid={`paper-card-${paper.slug}`}
      className="paper-card-item group relative rounded-xl overflow-hidden border border-[#1E2638] bg-[#131824] hover:border-sky-400/50 transition-colors duration-300 flex flex-col"
    >
      {paper.cover_url && (
        <div className="relative h-44 overflow-hidden">
          <img
            src={paper.cover_url}
            alt={paper.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#131824] via-transparent to-transparent" />
          {paper.supporters_only && (
            <span data-testid="paper-card-paywall-badge" className="absolute top-3 right-3 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-amber-400 bg-[#07090E]/85 backdrop-blur border border-amber-400/40 rounded-full px-2.5 py-1">
              <Lock className="w-3 h-3" /> Supporters
            </span>
          )}
        </div>
      )}
      <div className="p-6 flex flex-col flex-1">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-sky-400 mb-3">
          {String(index + 1).padStart(2, "0")} — {paper.category}
        </p>
        <h3 className="font-display font-semibold text-lg leading-snug mb-2.5 group-hover:text-sky-300 transition-colors">
          {paper.title}
        </h3>
        <p className="text-sm text-slate-400 leading-relaxed line-clamp-3 flex-1">{paper.abstract}</p>
        <div className="mt-5 pt-4 border-t border-[#1E2638] flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500">
          <span>{date}</span>
          <span className="flex items-center gap-4">
            <span className="flex items-center gap-1"><Eye className="w-3 h-3" /> {paper.views || 0}</span>
            {paper.pdf_url && (
              <span data-testid="paper-card-download-pdf" className="flex items-center gap-1 text-sky-400">
                <FileText className="w-3 h-3" /> PDF
              </span>
            )}
            <ArrowUpRight className="w-3.5 h-3.5 text-slate-600 group-hover:text-sky-400 transition-colors" />
          </span>
        </div>
      </div>
    </Link>
  );
}
